/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Typography, Form, Input, Button, message,
} from 'antd';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

export default function TestInterface({ test, candidate, onFinish }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const handleSubmit = async (values) => {
    setSubmitting(true);
    // Simula un envío de datos
    setTimeout(() => {
      message.success(`Respuestas de ${candidate.nombre} enviadas correctamente.`);
      setSubmitting(false);
      form.resetFields();
      onFinish();
    }, 1000);
  };

  return (
    <div className="space-y-6">
      <Title level={4}>{test.name}</Title>
      <Paragraph type="secondary">{test.description}</Paragraph>
      <Paragraph strong>
        Duración estimada:
        {' '}
        {test.duration}
      </Paragraph>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="mt-6"
      >
        {test.questions.map((q) => (
          <Form.Item
            key={q.id}
            label={q.text}
            name={`question_${q.id}`}
            rules={[{ required: true, message: 'Por favor responde esta pregunta.' }]}
          >
            <TextArea rows={4} placeholder="Escribe tu respuesta aquí..." />
          </Form.Item>
        ))}

        <Form.Item>
          <Button
            htmlType="submit"
            loading={submitting}
            style={{
              minWidth: 120,
              textAlign: 'center',
              background: '#235161',
              color: '#fff',
              border: 'none',
              fontWeight: 500,
              transition: 'background 0.2s',
            }}
            className="btn-prueba-disponible"
          >
            Finalizar prueba
          </Button>
        </Form.Item>
      </Form>
      <style>
        {`
          .btn-prueba-disponible:not([disabled]):hover {
            background: #16364a !important;
            color: #fff !important;
          }
        `}
      </style>
    </div>
  );
}
